import type { ProductList3Product } from "@/components/product-list3";
import type { ShoppingCart3Item } from "@/components/shopping-cart3";

export type Screen = "home" | "news" | "quick" | "cart" | "account" | "detail";
export type ProductStatus = "available" | "new" | "low" | "preorder";

export interface NineProduct {
  id: string;
  name: string;
  category: string;
  subcategory: string;
  fruit: string;
  packageWeight: string;
  origin: string;
  qualityTags: string[];
  price: number;
  originalPrice?: number;
  perKg: string;
  status: ProductStatus;
  badge?: string;
  badgeColor?: string;
  eta?: string;
  soldCount: number;
  gradient: [string, string];
}

export const categories = [
  { label: "Nho", fruit: "🍇", skuCount: 12 },
  { label: "Táo", fruit: "🍎", skuCount: 9 },
  { label: "Cherry", fruit: "🍒", skuCount: 7 },
  { label: "Kiwi", fruit: "🥝", skuCount: 6 },
  { label: "Cam", fruit: "🍊", skuCount: 8 },
  { label: "Lê", fruit: "🍐", skuCount: 5 },
  { label: "Dưa", fruit: "🍈", skuCount: 4 },
  { label: "Tất cả", fruit: "▦", skuCount: 51 },
];

export const products: NineProduct[] = [
  {
    id: "tao-gala",
    name: "Táo Gala đỏ nhập khẩu New Zealand",
    category: "Táo",
    subcategory: "Táo đỏ",
    fruit: "🍎",
    packageWeight: "Size 70 - 80 - 88 · Thùng 17.5-18kg",
    origin: "New Zealand",
    qualityTags: ["giòn", "đỏ đều", "ngọt nhẹ"],
    price: 1375000,
    originalPrice: 1450000,
    perKg: "78.500đ/kg",
    status: "available",
    badge: "-5%",
    badgeColor: "#ef3f26",
    soldCount: 102,
    gradient: ["#ffddd3", "#e9504b"],
  },
  {
    id: "nho-xanh",
    name: "Nho xanh không hạt Mỹ hàng bay",
    category: "Nho",
    subcategory: "Nho xanh",
    fruit: "🍇",
    packageWeight: "Thùng 8.6kg",
    origin: "Mỹ",
    qualityTags: ["giòn", "ngọt thanh", "không hạt"],
    price: 1962000,
    originalPrice: 2180000,
    perKg: "228.000đ/kg",
    status: "available",
    badge: "-10%",
    badgeColor: "#ef3f26",
    soldCount: 86,
    gradient: ["#def7b9", "#82cf65"],
  },
  {
    id: "nho-den",
    name: "Nho đen không hạt Chile",
    category: "Nho",
    subcategory: "Nho đen",
    fruit: "🍇",
    packageWeight: "Thùng 8kg",
    origin: "Chile",
    qualityTags: ["mọng nước", "ngọt đậm", "vỏ giòn"],
    price: 1030000,
    perKg: "128.750đ/kg",
    status: "new",
    badge: "Mới",
    badgeColor: "#17b86f",
    soldCount: 64,
    gradient: ["#d4b5ff", "#8e63d6"],
  },
  {
    id: "nho-ngon-tay",
    name: "Nho ngón tay Úc cao cấp nhập khẩu",
    category: "Nho",
    subcategory: "Nho đỏ",
    fruit: "🍇",
    packageWeight: "Thùng 9kg",
    origin: "Úc",
    qualityTags: ["dài thanh", "giòn ngọt", "không hạt"],
    price: 1330000,
    perKg: "147.800đ/kg",
    status: "low",
    badge: "Sắp hết",
    badgeColor: "#d97706",
    soldCount: 41,
    gradient: ["#d4b5ff", "#8e63d6"],
  },
  {
    id: "nho-do-hoa-hong",
    name: "Nho đỏ hoa hồng Mỹ",
    category: "Nho",
    subcategory: "Nho đỏ",
    fruit: "🍇",
    packageWeight: "Thùng 3.5kg",
    origin: "Mỹ",
    qualityTags: ["hàng đặt trước", "mùi thơm"],
    price: 0,
    perKg: "",
    status: "preorder",
    badge: "Sắp về",
    badgeColor: "#2563eb",
    eta: "09/06/2026",
    soldCount: 0,
    gradient: ["#ffc2db", "#f06aa7"],
  },
  {
    id: "cam-navel",
    name: "Cam vàng Navel ngọt nước Ai Cập",
    category: "Cam",
    subcategory: "Cam vàng",
    fruit: "🍊",
    packageWeight: "Size 48 - 56 - 64 · Thùng 17-18kg",
    origin: "Ai Cập",
    qualityTags: ["múi mọng", "vỏ mỏng", "ngọt"],
    price: 1825000,
    perKg: "101.000đ/kg",
    status: "new",
    badge: "Mới",
    badgeColor: "#17b86f",
    soldCount: 58,
    gradient: ["#ffd787", "#ff9d38"],
  },
  {
    id: "kiwi-vang",
    name: "Kiwi vàng VIP New Zealand",
    category: "Kiwi",
    subcategory: "Kiwi vàng",
    fruit: "🥝",
    packageWeight: "Thùng 2.2kg",
    origin: "New Zealand",
    qualityTags: ["ngọt thơm", "ruột vàng", "đẹp size"],
    price: 405000,
    perKg: "184.000đ/kg",
    status: "new",
    badge: "Mới",
    badgeColor: "#17b86f",
    soldCount: 76,
    gradient: ["#e5f6a9", "#9ed35a"],
  },
  {
    id: "le-sua",
    name: "Lê sữa VIP cao cấp nhập khẩu Hàn Quốc",
    category: "Lê",
    subcategory: "Lê sữa",
    fruit: "🍐",
    packageWeight: "Size 26 · Thùng 15kg",
    origin: "Hàn Quốc",
    qualityTags: ["mọng nước", "ngọt thanh", "vỏ mỏng"],
    price: 875000,
    originalPrice: 995000,
    perKg: "58.000đ/kg",
    status: "available",
    badge: "-12%",
    badgeColor: "#ef3f26",
    soldCount: 91,
    gradient: ["#fff2a1", "#e1c856"],
  },
  {
    id: "dua-luoi",
    name: "Dưa lưới Taki Nhật",
    category: "Dưa",
    subcategory: "Dưa lưới",
    fruit: "🍈",
    packageWeight: "4 quả · 6.8kg",
    origin: "Nhật",
    qualityTags: ["ngọt đậm", "thơm", "giòn"],
    price: 425000,
    perKg: "62.500đ/kg",
    status: "available",
    badge: "Mới",
    badgeColor: "#17b86f",
    soldCount: 39,
    gradient: ["#def7b9", "#82cf65"],
  },
  {
    id: "tao-pink",
    name: "Táo Pink Lady Mỹ",
    category: "Táo",
    subcategory: "Táo đỏ",
    fruit: "🍎",
    packageWeight: "Size 64 - 80 - 88 · Thùng 18-20kg",
    origin: "Mỹ",
    qualityTags: ["sắp về kho", "đặt giữ size"],
    price: 0,
    perKg: "",
    status: "preorder",
    badge: "Sắp về",
    badgeColor: "#e94aa2",
    eta: "12/06/2026",
    soldCount: 0,
    gradient: ["#ffc2db", "#f06aa7"],
  },
  {
    id: "tao-granny",
    name: "Táo xanh Granny Smith Úc",
    category: "Táo",
    subcategory: "Táo xanh",
    fruit: "🍏",
    packageWeight: "Size 88 · Thùng 18kg",
    origin: "Úc",
    qualityTags: ["chua thanh", "giòn mát", "ít ngọt"],
    price: 1620000,
    perKg: "90.000đ/kg",
    status: "low",
    badge: "Sắp hết",
    badgeColor: "#d97706",
    soldCount: 55,
    gradient: ["#d7f7cf", "#6fcf81"],
  },
  {
    id: "quyt-2ph",
    name: "Quýt 2PH - ngọt thanh, vỏ mỏng, giòn rôm",
    category: "Cam",
    subcategory: "Quýt",
    fruit: "🍊",
    packageWeight: "Size 48 · 18kg/thùng",
    origin: "Trung Quốc",
    qualityTags: ["vàng cam", "mọng nước", "vỏ mỏng"],
    price: 450000,
    perKg: "25.000đ/kg",
    status: "available",
    badge: "Hàng mới",
    badgeColor: "#17b86f",
    soldCount: 102,
    gradient: ["#ffd8b8", "#ff9f66"],
  },
];

export const articles = [
  ["MẸO BÁN", "4 mẹo trưng bày trái cây khiến khách dừng chân mua ngay", "🍎"],
  ["KIẾN THỨC", "Nhận biết trái cây tươi ngon chỉ trong 3 bước đơn giản", "🍓"],
  ["MẸO BÁN", "Quản lý hàng hóa hiệu quả - Giảm hao hụt, tăng lợi nhuận", "🥝"],
  ["THỊ TRƯỜNG", "Lịch mùa vụ trái cây 2026 - Nhập hàng đúng mùa, lời gấp đôi", "🍈"],
  ["GIÁ & HÀNG", "Cam Sunkist BAY về - size đẹp, giá tốt hơn tuần trước 9%", "🍊"],
] as const;

export const money = (value: number) =>
  new Intl.NumberFormat("vi-VN").format(value) + "đ";

export const findProduct = (id: string) =>
  products.find((product) => product.id === id) ?? products[0];

export const productImage = (product: NineProduct) => {
  const [from, to] = product.gradient;
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="600" height="600" viewBox="0 0 600 600"><defs><linearGradient id="g" x1="0" y1="0" x2="1" y2="1"><stop stop-color="${from}"/><stop offset="1" stop-color="${to}"/></linearGradient><filter id="s"><feDropShadow dx="0" dy="18" stdDeviation="16" flood-color="#54371f" flood-opacity=".18"/></filter></defs><rect width="600" height="600" rx="42" fill="url(#g)"/><text x="50%" y="54%" dominant-baseline="middle" text-anchor="middle" font-size="190" filter="url(#s)">${product.fruit}</text></svg>`;
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}`;
};

export const toListProduct = (product: NineProduct): ProductList3Product => ({
  id: product.id,
  name: product.name,
  image: {
    src: productImage(product),
    alt: product.name,
  },
  description: product.packageWeight,
  meta: product.perKg ? `≈ ${product.perKg}` : product.origin,
  unit: "/thùng",
  eta: product.eta,
  status: product.status,
  qualityTags: product.status === "preorder" ? [] : product.qualityTags,
  price: {
    regular: product.originalPrice ?? product.price,
    sale: product.originalPrice ? product.price : undefined,
    currency: "VND",
  },
  badge: product.badge
    ? {
        text: product.badge,
        color: product.badgeColor,
      }
    : undefined,
});

export const fromListProduct = (product: ProductList3Product) =>
  findProduct(product.id);

export const toCartItem = (
  product: NineProduct,
  quantity = 1,
): ShoppingCart3Item => ({
  id: product.id,
  name: product.name,
  image: productImage(product),
  price: product.price,
  quantity,
  variant: product.packageWeight,
});
